export default "__VITE_PUBLIC_ASSET__bcffe4d2__"